import { useEffect } from "react";
import { useState } from "react";
import { projectsData } from "../data";
import { projectsNav } from "../data";
import Project from "./Project";

function Projects() {
  const [item, setItem] = useState({ name: "all" });
  const [project, setProjects] = useState([]);
  const [active, setActive] = useState(0);
  useEffect(() => {
    if (item.name === "all") {
      setProjects(projectsData);
    } else {
      const newProjects = projectsData.filter((project) => {
        return project.category.toLowerCase() === item.name;
      });
      setProjects(newProjects);
    }
  }, [item]);

  const handleClick = (e, index) => {
    setItem({ name: e.target.textContent.toLowerCase() });
    setActive(index);
  };
  return (
    <div>
      <nav className="mb-12 max-w-xl mx-auto">
        <ul className="flex flex-col md:flex-row justify-evenly items-center text-white">
          {projectsNav.map((item, index) => {
            return (
              <li
                onClick={(e) => {
                  handleClick(e, index);
                }}
                className={`${
                  active === index ? "active" : ""
                }cursor-pointer capitalize m-4`}
                key={index}
              >
                {item.name}
              </li>
            );
          })}
        </ul>
      </nav>
      {/* project Grid  */}
      <section className="grid align-items:center lg:grid-cols-3 gap-y-12 lg:gap-x-8 lg:gap-y-8">
        {project.map((item, i) => {
          return <Project item={item} key={item.id} />;
        })}
      </section>
      <h1 style={{textAlign:"center",margin:"30px"}} className="text-xl leading-[44px] md:text-2xl  lg:text-4xl lg:leading-[1.2]">
        My Github Stat's
      </h1>
      
      <section className="grid align-items:center lg:grid-cols-2 gap-y-12 lg:gap-x-8 lg:gap-y-8">
        <img
          src="https://i.postimg.cc/JntTgt9N/gitstat.png"
          width={"600px"}
          alt=""
        />
        <img
          src="https://i.postimg.cc/0NVWc7H5/gitstrike.png"
          width={"600px"}
          alt=""
        />
      </section>
      <section style={{margin:"100px"}}>
        <img
          src="https://i.postimg.cc/MG63795r/contri.png"
          width={"900px"}
          alt=""
        />
      </section>
    </div>
  );
}

export default Projects;
